import publicApi from "@/services/publicApi";

export const jobRoleSearchPublicApiCall = (input: string, callback: any) => {
  return publicApi
    .getRoles({ search: input })
    .then((res) => callback(res.data.results));
};

export const skillSearchPublicApiCall = (input: string, callback: any) => {
  return publicApi
    .getSkills({ search: input })
    .then((res) => callback(res.data.results));
};

export const industrySearchPublicApiCall = (input: string, callback: any) => {
  return publicApi
    .getIndustries({
      search: input,
    })
    .then((res) => callback(res.data.results));
};
